import React from 'react'
import { textBlockNestedClasses } from '../../../../../../utils/style'
import { getClassName } from '../../../../../../utils/utils'
import { useInView } from '../../../../../hooks/useInView'
import { TextBlockNested } from '../../../blocksState'

export type TextBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  textClassName: string
}>

export const TextBlockNestedLayout = (props: TextBlockNested) => {
  const { inview, index, text } = props
  const classes = textBlockNestedClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("TextBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'pt-3')}>
        {text && (
          <div className={getClassName(classes, 'contentClassName', '')}>
            <div
              className={getClassName(classes, 'textClassName', '')}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        )}
      </div>
    </section>
  )
}
